<template>
  <div>
    <div
      v-if="showCurrentRegroupement"
      class="row"
    >
      <div class="selected-articles">
        <div class="selected-article">
          <label for="regroupementTitle">
            Titre du regroupement :
          </label>
          <input
            id="regroupementTitle"
            v-model="regroupementTitle"
          >
        </div>
        <div class="selected-article">
          <label for="regroupementCanonicalTag">
            Balise canonique :
          </label>
          <input
            id="regroupementCanonicalTag"
            v-model="regroupementCanonicalTag"
          >
        </div>
        <div class="selected-article">
          <button
            @click="openPlanVenteBrowser()"
          >
            Choix des articles
          </button>
        </div>
        <div class="selected-article">
          <h3>
            Désignation du regroupement :
          </h3>
          <p><i>L'article sélectionné est l'article maître</i></p>
          <ul class="selected-articles__list">
            <li
              v-for="article of currentRegroupementArticles"
              :key="article.codeArticle"
              class="selected-articles__article"
            >
              <input
                :id="article.codeArticle"
                v-model="masterArticle"
                type="radio"
                :value="article.codeArticle"
              >
              <label
                :for="article.codeArticle"
              >
                {{ article.designation1 }} - {{ article.codeArticle }}
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div class="attributs">
        <h3>
          ATTRIBUTS DE REGROUPEMENT
        </h3>
        <div
          v-if="typeRegroupement == '0'"
          :class="{ warned : isWarned }"
        >
          2 attributs maximum
        </div>
        <ul class="attributs__list">
          <li
            v-for="attribut of currentRegroupementAvailableAttributs"
            :key="attribut.propriete"
            class="attribut"
          >
            <input
              :id="attribut.propriete"
              :checked="isAttributChecked(attribut)"
              type="checkbox"
              :value="attribut.propriete"
              @click="onClick(attribut, $event)"
            >
            <label :for="attribut.propriete">
              {{ attribut.propriete }}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <p>
      <button
        @click="toggleRegroupementEditMode"
      >
        Retour
      </button>
      <button
        v-if="showCurrentRegroupement"
        @click="saveRegroupement"
      >
        Enregistrer le regroupement
      </button>
      <button
        v-if="!bootstrapMode"
        @click="deleteRegroupement"
      >
        Supprimer le regroupement
      </button>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    typeRegroupement: {
      type: String,
      default: '0'
    }
  },
  data: function() {
    return {
      isWarned: false
    }
  },
  computed: {
    ...mapGetters([
      'regroupements',
      'currentRegroupement',
      'currentRegroupementArticles',
      'currentRegroupementAttributs',
      'currentRegroupementAvailableAttributs',
      'currentRegroupementArticleMaitre'
    ]),
    regroupementCanonicalTag: {
      get() {
        return this.currentRegroupement.canonicalTag
      },
      set(tag) {
        this.setRegroupementCanonicalTag(tag)
      }
    },
    regroupementTitle: {
      get() {
        return this.currentRegroupement.titre
      },
      set(title) {
        this.setRegroupementTitle(title)
      }
    },
    masterArticle: {
      get() {
        return this.currentRegroupementArticleMaitre.codeArticle
      },
      set(codeArticle) {
        this.setRegroupementMasterArticle(this.currentRegroupementArticles[codeArticle])
      }
    },
    bootstrapMode() {
      return this.currentRegroupement.id === null
    },
    regroupement() {
      return this.bootstrapMode
        ? this.currentRegroupement
        : this.regroupements[this.regroupementId]
    },
    title() {
      return this.bootstrapMode ? 'Créer un regroupement' : this.currentRegroupement.libelle
    },
    showCurrentRegroupement() {
      return Object.keys(this.currentRegroupementArticles).length >= 1
    }
  },
  mounted() {
    if (this.bootstrapMode) this.openPlanVenteBrowser()
  },
  methods: {
    ...mapActions([
      'openPlanVenteBrowser',
      'setRegroupementMasterArticle',
      'saveRegroupement',
      'deleteRegroupement',
      'selectAttribut',
      'toggleRegroupementEditMode',
      'setRegroupementCanonicalTag',
      'setRegroupementTitle'
    ]),
    isAttributChecked(attribut) {
      const isChecked = this.currentRegroupementAttributs.some(currentRegroupementAttribut => {
        let { nature } = attribut
        nature = nature !== undefined ? nature : 'OPT'
        return currentRegroupementAttribut.propriete === attribut.propriete &&
          currentRegroupementAttribut.nature === nature
      })
      return isChecked
    },
    onClick(attribut, event) {
      this.selectAttribut(attribut).then( success => {
        if (!success) {
          this.isWarned = true
          event.preventDefault()
        } else {
          this.isWarned = false
        }
      })
    }
  }
}
</script>

<style scoped>

label {
  margin-left: 0.5rem;
}

.row {
  display: flex;
  padding: 0;
}

.selected-articles {
  display: flex;
  flex-direction: column;
  margin: 0 5rem 2rem 0;
}

.selected-articles__article {
  display: flex;
  margin: 0.2rem 0;
}

.selected-articles__article input {
  margin-top: 0;
}

.selected-articles__article > label {
  font-weight: 500;
}

.selected-articles__list {
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.selected-article {
  margin: 1rem 0 0;
}

.selected-article h3 {
  margin: 0 0 1rem;
}

.selected-article > label {
  margin-bottom: 0.5em;
  margin-left: 0;
  font-weight: bold;
}

.selected-article > input {
  width: 40rem;
}

.attributs {
  display: flex;
  flex-direction: column;
}

.attributs__list {
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.attribut {
  display: flex;
}

.attribut > label {
  font-weight: 400;
  text-transform: capitalize;
}

.warned {
  color: red;
}
</style>
